module.exports = __webpack_public_path__ + "img/logo_unillanos.e3e01063.png";